module.exports = __webpack_public_path__ + "static/media/product-hardware.c492f811.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/product-hardware.svg
// module id = 161
// module chunks = 6